// Compatibility re-export (BKPE-27795). See `features/observability/logger/middleware`.
export * from 'features/observability/logger/middleware';
